export default [
  {
    label: "首页",
    link: "/home/index",
  },
  {
    label: "能源",
    name: "report",
    params: {
      target: "能源",
    },
  },
  {
    label: "化工",
    name: "report",
    params: {
      target: "化工",
    },
  },
  {
    label: "农化",
    name: "report",
    params: {
      target: "农化",
    },
  },
  {
    label: "煤化工",
    name: "report",
    params: {
      target: "煤化工",
    },
  },
  {
    label: "橡塑",
    name: "report",
    params: {
      target: "橡塑",
    },
  },
  {
    label: "聚氨酯",
    name: "report",
    params: {
      target: "聚氨酯",
    },
  },
  {
    label: "农业",
    name: "report",
    params: {
      target: "农业",
    },
  },
  {
    label: "钢铁",
    name: "report",
    params: {
      target: "钢铁",
    },
  },
  {
    label: "有色",
    name: "report",
    params: {
      target: "有色",
    },
  },
  {
    label: "非金建材",
    name: "report",
    params: {
      target: "非金建材",
    },
  },
  {
    label: "纸品",
    name: "report",
    params: {
      target: "纸品",
    },
  },
  {
    label: "新材料",
    name: "report",
    params: {
      target: "新材料",
    },
  },
]